export const SMSES_GET_MESSAGES_START = 'SMSES_GET_MESSAGES_START';
export const SMSES_GET_MESSAGES_SUCCESS = 'SMSES_GET_MESSAGES_SUCCESS';
export const SMSES_GET_MESSAGES_FAIL = 'SMSES_GET_MESSAGES_FAIL';

export const SMSES_SET_MESSAGES = 'SMSES_SET_MESSAGES';

export const SMSES_GET_INSUREDS_PHONES_START = 'SMSES_GET_INSUREDS_PHONES_START';
export const SMSES_GET_INSUREDS_PHONES_SUCCESS = 'SMSES_GET_INSUREDS_PHONES_SUCCESS';
export const SMSES_GET_INSUREDS_PHONES_FAIL = 'SMSES_GET_INSUREDS_PHONES_FAIL';

export const SMSES_SEND_MESSAGE_START = 'SMSES_SEND_MESSAGE_START';
export const SMSES_SEND_MESSAGE_SUCCESS = 'SMSES_SEND_MESSAGE_SUCCESS';
export const SMSES_SEND_MESSAGE_FAIL = 'SMSES_SEND_MESSAGE_FAIL';

export const SMSES_GET_MESSAGE_CONTROL_PARAMETERS_START = 'SMSES_GET_MESSAGE_CONTROL_PARAMETERS_START';
export const SMSES_GET_MESSAGE_CONTROL_PARAMETERS_SUCCESS = 'SMSES_GET_MESSAGE_CONTROL_PARAMETERS_SUCCESS';
export const SMSES_GET_MESSAGE_CONTROL_PARAMETERS_FAIL = 'SMSES_GET_MESSAGE_CONTROL_PARAMETERS_FAIL';

export const SMSES_GET_ALL_INSURED_NUMBERS_START = 'SMSES_GET_ALL_INSURED_NUMBERS_START';
export const SMSES_GET_ALL_INSURED_NUMBERS_SUCCESS = 'SMSES_GET_ALL_INSURED_NUMBERS_SUCCESS';
export const SMSES_GET_ALL_INSURED_NUMBERS_FAIL = 'SMSES_GET_ALL_INSURED_NUMBERS_FAIL';

export const SMSES_GET_UPDATES_START = 'SMSES_GET_UPDATES_START';
export const SMSES_GET_UPDATES_SUCCESS = 'SMSES_GET_UPDATES_SUCCESS';
export const SMSES_GET_UPDATES_FAIL = 'SMSES_GET_UPDATES_FAIL';

export const SMSES_SET_LOCAL_MESSAGES = 'SMSES_SET_LOCAL_MESSAGES';

export const SMSES_SEND_MASS_MESSAGES_START = 'SMSES_SEND_MASS_MESSAGES_START';
export const SMSES_SEND_MASS_MESSAGES_SUCCESS = 'SMSES_SEND_MASS_MESSAGES_SUCCESS';
export const SMSES_SEND_MASS_MESSAGES_FAIL = 'SMSES_SEND_MASS_MESSAGES_FAIL';

export const SMSES_SET_UPDATES = 'SMSES_SET_UPDATES';

export const SMSES_CHECK_PHONE_NUMBER_START = 'SMSES_CHECK_PHONE_NUMBER_START';
export const SMSES_CHECK_PHONE_NUMBER_SUCCESS = 'SMSES_CHECK_PHONE_NUMBER_SUCCESS';
export const SMSES_CHECK_PHONE_NUMBER_FAIL = 'SMSES_CHECK_PHONE_NUMBER_FAIL';

export const SMSES_SET_MESSAGE_CONTROL_PARAMETERS_SUCCESS = 'SMSES_SET_MESSAGE_CONTROL_PARAMETERS_SUCCESS';

export const SMSES_START_MIGRATION_START = 'SMSES_START_MIGRATION_START';
export const SMSES_START_MIGRATION_SUCCESS = 'SMSES_START_MIGRATION_SUCCESS';
export const SMSES_START_MIGRATION_FAIL = 'SMSES_START_MIGRATION_FAIL';

export const SMSES_SAVE_MIGRATION_START = 'SMSES_SAVE_MIGRATION_START';
export const SMSES_SAVE_MIGRATION_SUCCESS = 'SMSES_SAVE_MIGRATION_SUCCESS';
export const SMSES_SAVE_MIGRATION_FAIL = 'SMSES_SAVE_MIGRATION_FAIL';

export const SMSES_SET_SELECTED_CHAT_ITEM = 'SMSES_SET_SELECTED_CHAT_ITEM';

export const SMSES_CLEAR_MESSAGE_TO_INFORM = 'SMSES_CLEAR_MESSAGE_TO_INFORM';
export const SMSES_CLEAR_MESSAGE_CONTROL_ERROR = 'SMSES_CLEAR_MESSAGE_CONTROL_ERROR';
